import React from 'react';
import './StandardSettings.css';

const StandardSettings = ({ pageSettings, onSettingsChange }) => {
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "customDomain") {
            const sanitizedValue = value.replace(/[^a-z0-9-]/gi, '').toLowerCase();
            onSettingsChange(name, sanitizedValue);
        } else if (name === "whatsappNumber") {
            const newValue = value.replace(/[^0-9]/g, '');
            onSettingsChange(name, newValue);
        } else if (name === "translate1") {
            onSettingsChange(name, checked);
            if (checked) {
                onSettingsChange("translate2", false);
            }
        } else if (name === "translate2") {
            onSettingsChange(name, checked);
            if (checked) {
                onSettingsChange("translate1", false);
            }
        } else {
            onSettingsChange(name, type === 'checkbox' ? checked : value);
        }
    };

    return (
        <div className="standard-settings-premium">
            <h3 className="settings-section-title">Standard Settings</h3>
            
            {/* Page Information - Full Width */}
            <div className="settings-grid settings-grid--single">
                <div className="settings-field settings-grid--full-width">
                    <label className="settings-label">Page Name</label>
                    <input 
                        type="text" 
                        name="name" 
                        value={pageSettings.name || ''} 
                        onChange={handleChange} 
                        placeholder="Enter your page name" 
                        className="settings-input"
                    />
                </div>

                <div className="settings-field settings-grid--full-width">
                    <label className="settings-label">Page Description</label>
                    <textarea 
                        name="description" 
                        value={pageSettings.description || ''} 
                        onChange={handleChange} 
                        placeholder="Describe what your page is about..." 
                        className="settings-textarea"
                    />
                </div>

                <div className="settings-field settings-grid--full-width">
                    <label className="settings-label">Page Link</label>
                    <div className="custom-domain-input">
                        <span className="domain-prefix">bonusclub.link/to/</span>
                        <input
                            type="text"
                            name="customDomain"
                            value={pageSettings.customDomain || ''}
                            onChange={handleChange}
                            placeholder="your-custom-link"
                            className="domain-input"
                        />
                    </div>
                </div>
            </div>

            {/* Communication Settings - 2 Column Grid */}
            <div className="settings-grid">
                <div className="settings-field">
                    <label className="settings-label">WhatsApp Integration</label>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            name="whatsappStatus"
                            checked={pageSettings.whatsappStatus || false}
                            onChange={handleChange}
                        />
                        <span className="toggle-slider"></span>
                    </label>
                    <p className="settings-field-description">Enable WhatsApp contact button</p>
                </div>

                <div className="settings-field">
                    <label className="settings-label">WhatsApp Number</label>
                    <input
                        type="text"
                        name="whatsappNumber"
                        value={pageSettings.whatsappNumber || ''}
                        onChange={handleChange}
                        placeholder="491701234567"
                        className="settings-input"
                    />
                    <p className="settings-field-description">Country code without +</p>
                </div>
            </div>

            {/* Translation Settings - 2 Column Grid */}
            <div className="settings-grid">
                <div className="settings-field">
                    <label className="settings-label">Google Translate (Light)</label>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            name="translate2"
                            checked={pageSettings.translate2 || false}
                            onChange={handleChange}
                        />
                        <span className="toggle-slider"></span>
                    </label>
                    <p className="settings-field-description">Light theme translator</p>
                </div>

                <div className="settings-field">
                    <label className="settings-label">Google Translate (Dark)</label>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            name="translate1"
                            checked={pageSettings.translate1 || false}
                            onChange={handleChange}
                        />
                        <span className="toggle-slider"></span>
                    </label>
                    <p className="settings-field-description">Dark theme translator</p>
                </div>
            </div>

        </div>
    );
};

export default StandardSettings;
